import { render } from "./BackgroundVideo.vue?vue&type=template&id=4e4a6c9a&scoped=true&ts=true"
import script from "./BackgroundVideo.vue?vue&type=script&lang=ts"
export * from "./BackgroundVideo.vue?vue&type=script&lang=ts"

import "./BackgroundVideo.vue?vue&type=style&index=0&id=4e4a6c9a&scoped=true&lang=css"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4a6c9a"]])

export default __exports__